<template>
  <div class="user-info">
    <div class="system-name">
      {{ systemName }}
    </div>
    <img src="@app/assets/images/default-user.png" alt="user">
    <div class="user-info-right">
      <div class="company-name">
        {{ companyName }}
      </div>
      <div class="user-name">
        {{ username }}
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { ESystemType } from '@core/api';
import { useUserStore } from '@core/main';
import { computed } from 'vue';

const { state: userState } = useUserStore();

const userInfo = computed(() => userState);
const identity = computed(() => userInfo.value.identity);
const systemType = computed(() => identity.value.systemType);
const username = computed(() => userInfo.value.name);
const systemName = computed(() => systemType.value === ESystemType.SAAS
  ? '运营'
  : systemType.value === ESystemType.Company
    ? '企业'
    : systemType.value === ESystemType.Agent ? '代理商' : '服务商');
const companyName = computed(() => systemType.value === ESystemType.SAAS
  ? '总运营后台'
  : systemType.value === ESystemType.Company
    ? identity.value.companyDTO?.companyName
    : systemType.value === ESystemType.Agent ? identity.value.agentDTO?.agentName : identity.value.serverDTO.serverName);

</script>

<style lang="scss" scoped>
.user-info {
  @apply relative w-full h-[88px] flex items-center gap-x-2 px-3 bg-[url('@core/main/src/modules/homepage/imgs/user-info.png')] bg-no-repeat bg-center bg-[length:100%_100%];

  .system-name {
    @apply w-[64px] h-[23px] leading-[23px] text-center absolute right-0 top-0 text-[var(--color-primary)] text-[12px];
  }

  img{
    @apply w-[48px] h-[48px] rounded-full border-[#D9ECFF];
  }

  .user-info-right {
    @apply flex flex-wrap gap-y-2 w-[calc(100%-90px)];

    .company-name {
      @apply text-[var(--color-text-white)] text-[16px] w-full truncate;
    }

    .user-name {
      @apply text-[var(--color-text-white)] text-[14px] w-full truncate;
    }
  }
}
</style>
